module.exports = __webpack_public_path__ + "img/instagram.2ebdd988.svg";